
/** This file is auto-generated by Plasmic; please do not edit! */
import * as React from 'react';


import HomeasqKkLevLrSacxedRcECnU from "/opt/build/repo/.cache/.plasmic/components/plasmic/starter_blog/PlasmicHome.jsx";

import HomeHeaderasqKkLevLrSacxedRcECnU from "/opt/build/repo/.cache/.plasmic/components/plasmic/starter_blog/PlasmicHomeHeader.jsx";

import ListItemasqKkLevLrSacxedRcECnU from "/opt/build/repo/.cache/.plasmic/components/plasmic/starter_blog/PlasmicListItem.jsx";

import FooterasqKkLevLrSacxedRcECnU from "/opt/build/repo/.cache/.plasmic/components/plasmic/starter_blog/PlasmicFooter.jsx";

import PostasqKkLevLrSacxedRcECnU from "/opt/build/repo/.cache/.plasmic/components/plasmic/starter_blog/PlasmicPost.jsx";

import PostHeaderasqKkLevLrSacxedRcECnU from "/opt/build/repo/.cache/.plasmic/components/plasmic/starter_blog/PlasmicPostHeader.jsx";

import AuthorBioasqKkLevLrSacxedRcECnU from "/opt/build/repo/.cache/.plasmic/components/plasmic/starter_blog/PlasmicAuthorBio.jsx";

import PlasmicLogoIconasqKkLevLrSacxedRcECnU from "/opt/build/repo/.cache/.plasmic/components/plasmic/starter_blog/icons/PlasmicIcon__PlasmicLogo.jsx";


/** This file is auto-generated by Plasmic; please do not edit! */


import { ScreenVariantProvider as ScreenasqKkLevLrSacxedRcECnU } from "/opt/build/repo/.cache/.plasmic/components/plasmic/starter_blog/PlasmicGlobalVariant__Screen.jsx";



const componentsWithOneProject = {
  
  "Home": HomeasqKkLevLrSacxedRcECnU,
  
  "HomeHeader": HomeHeaderasqKkLevLrSacxedRcECnU,
  
  "ListItem": ListItemasqKkLevLrSacxedRcECnU,
  
  "Footer": FooterasqKkLevLrSacxedRcECnU,
  
  "Post": PostasqKkLevLrSacxedRcECnU,
  
  "PostHeader": PostHeaderasqKkLevLrSacxedRcECnU,
  
  "AuthorBio": AuthorBioasqKkLevLrSacxedRcECnU,
  
  "PlasmicLogoIcon": PlasmicLogoIconasqKkLevLrSacxedRcECnU,
  
};

const providersWithOneProject = {
  
  "Screen": {
    "component": ScreenasqKkLevLrSacxedRcECnU,
    "isContext": !Boolean( "ScreenVariantProvider" ),
  },
  
};

const componentMap = {
  
  "Home": {
    
    "asqKkLevLrSacxedRcECnU": HomeasqKkLevLrSacxedRcECnU,
    
  },
  
  "HomeHeader": {
    
    "asqKkLevLrSacxedRcECnU": HomeHeaderasqKkLevLrSacxedRcECnU,
    
  },
  
  "ListItem": {
    
    "asqKkLevLrSacxedRcECnU": ListItemasqKkLevLrSacxedRcECnU,
    
  },
  
  "Footer": {
    
    "asqKkLevLrSacxedRcECnU": FooterasqKkLevLrSacxedRcECnU,
    
  },
  
  "Post": {
    
    "asqKkLevLrSacxedRcECnU": PostasqKkLevLrSacxedRcECnU,
    
  },
  
  "PostHeader": {
    
    "asqKkLevLrSacxedRcECnU": PostHeaderasqKkLevLrSacxedRcECnU,
    
  },
  
  "AuthorBio": {
    
    "asqKkLevLrSacxedRcECnU": AuthorBioasqKkLevLrSacxedRcECnU,
    
  },
  
  "PlasmicLogoIcon": {
    
    "asqKkLevLrSacxedRcECnU": PlasmicLogoIconasqKkLevLrSacxedRcECnU,
    
  },
  
};

const providerMap = {
  
  "Screen": {
    
    "asqKkLevLrSacxedRcECnU": {
      "component": ScreenasqKkLevLrSacxedRcECnU,
      "isContext": !Boolean(undefined),
    },
    
  },
  
};

const pagesByUrl = {
  
    "/home": {name: "Home", projectId: "asqKkLevLrSacxedRcECnU" },
  
    "/post": {name: "Post", projectId: "asqKkLevLrSacxedRcECnU" },
  
};

export function getPageUrls() {
  return Object.keys(pagesByUrl);
}

export function getComponentFromUrl(url) {
  if (Array.isArray(url)) {
    url = url.join("/");
  }
  if (!url.startsWith('/')) {
    url = '/' + url;
  }
  return pagesByUrl[url];
}

function getComponent(projectId, component) {
  if (componentsWithOneProject[component]) {
    return componentsWithOneProject[component];
  }
  if (!componentMap[component]) {
    throw new Error(`The component ${component} could not be found.`);
  }
  if (!componentMap[component][projectId]) {
    throw new Error(`The component ${component} requires a valid projectId. Passed: ${projectId}. Options: ${Object.keys(componentMap[component])}`);
  }
  return componentMap[component][projectId];
};

function renderWithProviders(component, projectId, providersWithProps) {
  const providers = Object.entries(providersWithProps || {}).map(([provider, value]) => {
    if (providersWithOneProject[provider]) {
      const {component, isContext} = providersWithOneProject[provider];
      return [isContext ? component.Provider :component, value];
    }
    if (!providerMap[provider]) {
      throw new Error(`The provider ${provider} could not be found.`);
    }
    if (!providerMap[provider][projectId]) {
      throw new Error(`The provider ${provider} requires a valid projectId. Passed: ${projectId}. Options: ${Object.keys(providerMap[provider])}`);
    }
    const {component, isContext} = providerMap[provider][projectId];
    return [isContext ? component.Provider : component, value];
  });

  if (!providers.length) {
    return component;
  }

  return providers.reduce((child, [wrapper, value]) => React.createElement(wrapper, {value}, child), component);
};

export function Providers({projectId, props = {}, children}) {
  return renderWithProviders(children, projectId, props);
}

export default function PlasmicLoader({ projectId, component, componentProps = {}, providerProps = {} }) {
  const Component = getComponent(projectId, component);
  return renderWithProviders(React.createElement(Component, componentProps), projectId, providerProps);
};
